"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const locale = {
  placeholder: 'Enter IP range',
  or: 'or',
  errorMsg: {
    INVALID: 'Incorrect IP range format. Enter a correct IP range. ',
    INVALID_SUBNET: 'IP range is not in the subnet IP range. Enter an available IP range within the range of {{data}}.',
    EXCLUDES: 'IP range is used. Enter an available IP range.',
    EXISTS: 'IP range is duplicated. Enter an available IP range.'
  }
};
var _default = exports.default = locale;